const hiddenClass = "selling_plan_theme_integration--hidden";

const isBundlePDP = document.body.classList.contains("essential-starter-bundle");


// Utility Functions
const PriceUtils = {
  // Parse formatted price strings to numeric values
  parsePrice(priceString) {
    return parseFloat(priceString.replace(/[^0-9.-]+/g, ""));
  },

  // Calculate savings percentage between two prices
  calculateSavingsPercentage(originalPrice, discountedPrice) {
    if (!originalPrice || originalPrice <= discountedPrice) return 0;
    return parseFloat(((originalPrice - discountedPrice) * 100.0 / originalPrice).toFixed(2));
  },

  // Format price for display (remove decimals if whole number)
  formatPriceForDisplay(price) {
    const numericPrice = parseFloat(price);
    return numericPrice % 1 === 0 ? numericPrice.toFixed(0) : numericPrice.toFixed(2);
  }
};

// DOM Manipulation Functions
const DOMUpdater = {
  // Update main price display
  updateMainPriceDisplay(allocationPrice) {
    const formattedPrice = PriceUtils.formatPriceForDisplay(allocationPrice);
    const priceElement = document.querySelector(".money[data-price]");
    if (priceElement) {
      priceElement.innerHTML = `$${formattedPrice}`;
    }
  },

  // Update compare-at price display
  updateCompareAtPriceDisplay(compareAtPrice, hasComparePrice) {
    const compareElement = document.querySelector(".price__compare-at--single-custom");
    if (compareElement) {
      compareElement.innerHTML = hasComparePrice ? compareAtPrice : "";
    }

  },

  // Update all savings display elements
  updateSavingsDisplay(percentageSaved) {
    const savePriceBelow = document.querySelector(".save-price-below");
    if (savePriceBelow) {
      savePriceBelow.innerHTML = percentageSaved > 0 ? `Save ${percentageSaved}%` : "";
    }
  },
  updateSavingsDisplaySubscriptionOnly(percentageSaved) {

    document.querySelectorAll(".price-offer").forEach(element => {
      element.innerHTML = percentageSaved > 0 ? `(Save ${percentageSaved}%` : "";
    });
  },


  // Manage price element styling and visibility
  managePriceElementLayout(numericAllocationPrice, numericVariantPrice, hasComparePrice) {
    const priceElement = document.getElementById("price_compared_sub_span");
    const savePriceBelow = document.querySelector(".save-price-below");

    if (!priceElement || !savePriceBelow) return;

    const shouldHideSavings = (numericAllocationPrice === numericVariantPrice) && !hasComparePrice;

    if (shouldHideSavings) {
      priceElement.style.marginRight = "0px";
      savePriceBelow.style.display = "none";
    } else {
      priceElement.style.marginRight = "11px";
      savePriceBelow.style.display = "block";
    }

    priceElement.style.display = "block";
  }

};

// Main refactored function - clean and modular


    function updatePriceAndSavePercentage(allocationPrice, compareAtPrice, variantPrice) {

    // Parse all prices to numeric values
    const numericCompareAtPrice = PriceUtils.parsePrice(compareAtPrice);
    const numericAllocationPrice = PriceUtils.parsePrice(allocationPrice);
    const numericVariantPrice = PriceUtils.parsePrice(variantPrice);

    // Determine if we have a valid compare price
    const hasComparePrice = !!numericCompareAtPrice && numericCompareAtPrice > numericAllocationPrice;

    // Update layout and styling
    DOMUpdater.managePriceElementLayout(numericAllocationPrice, numericVariantPrice, hasComparePrice);

    // Update main price display
    DOMUpdater.updateMainPriceDisplay(allocationPrice);

    // Get subscription price (preserved from original functionality)
    let subscriptionPrice = document.querySelector('section.selling_plan_theme_integration.active .price--subscribe')?.getAttribute('data-allocation-price');
    subscriptionPrice= PriceUtils.parsePrice(subscriptionPrice);

    // Update compare-at price display
    DOMUpdater.updateCompareAtPriceDisplay(compareAtPrice, hasComparePrice);

    // Calculate and update savings percentage
    const referencePrice = hasComparePrice ? numericCompareAtPrice : numericVariantPrice;
    const percentageSaved = PriceUtils.calculateSavingsPercentage(referencePrice, numericAllocationPrice);

    DOMUpdater.updateSavingsDisplay(percentageSaved);


    const subscriptReferencePrice = hasComparePrice ? numericCompareAtPrice : numericVariantPrice;
    const percentageSavedSubscriptionOnly = PriceUtils.calculateSavingsPercentage(subscriptReferencePrice, subscriptionPrice);

    DOMUpdater.updateSavingsDisplaySubscriptionOnly(percentageSavedSubscriptionOnly);

    }

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.listenToPurchaseFrequencyChange();
    this.listToRadioInputChange();
    this.setInitialSelectedSellingPlan();
  }

  listenToPurchaseFrequencyChange() {
    const purchaseFrequencySelects =
      this.sellingPlansWidgetContainer.querySelectorAll(
        "select.purchase_frequency"
      );
    purchaseFrequencySelects.forEach((select) => {
      const setInitialValue = () => {
        const selectedOptionValue = select.value;
        const parentContainer = select.closest(".subscribe_container");
        const radioInput = parentContainer.querySelector('input[type="radio"]');
        radioInput.dataset.sellingPlanId = selectedOptionValue;
      };
      setInitialValue();
      select.addEventListener("change", (event) => {
        const selectedOptionValue = event.target.value;
        const parentContainer = event.target.closest(".subscribe_container");
        const radioInput = parentContainer.querySelector('input[type="radio"]');
        radioInput.dataset.sellingPlanId = selectedOptionValue;
        purchaseFrequencySelects.forEach((otherSelect) => {
          if (otherSelect !== select) {
            otherSelect.value = selectedOptionValue;
            const otherParentContainer = otherSelect.closest(
              ".subscribe_container"
            );
            const otherRadioInput = otherParentContainer.querySelector(
              'input[type="radio"]'
            );
            otherRadioInput.dataset.sellingPlanId = selectedOptionValue;
          }
        });
      });
    });
  }

  listToRadioInputChange() {
    const radioInputs = this.sellingPlansWidgetContainer.querySelectorAll(
      'input[type="radio"]'
    );
    radioInputs.forEach((input) => {
      input.addEventListener("click", function () {
        if (this.hasAttribute("data-radio-type")) {
          const radioType = this.getAttribute("data-radio-type");
          const relatedInputs = document.querySelectorAll(
            `input[data-radio-type="${radioType}"]`
          );
          relatedInputs.forEach((relatedInput) => {
            if (relatedInput !== this) {
              relatedInput.checked = this.checked;
            }
          });
        }
      });
    });
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute("data-section-id");
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  /*
    We are careful to target the correct form, as there are instances when we encounter an installment form that we specifically aim to avoid interacting with.
  */
  get variantIdInput() {
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0].querySelector(`input[name="id"]`) ||
      this.addToCartForms[0].querySelector(`select[name="id"]`)
    );
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`
    );
  }

  get isVariantAvailable() {
    return this.selectedPurchaseOption.getAttributeNames().includes("disabled");
  }

  get sellingPlanInput() {
    return this.shopifySection.querySelector(".selected-selling-plan-id");
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll(
      '[data-product-form][action*="/cart/add"]'
    );
  }

  /*
    To enable the addition of a selling plan to a cart, it's necessary to include an input with the name "selling_plan", which will carry the selling ID as its value. When a buyer clicks on 'add to cart', the appropriate selling plan ID is added to their cart.
  */
  appendSellingPlanInputs() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
    sellingPlanFormForSelectedVariant?.classList?.add("active");
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
      element.classList.remove("active");
    });
  }

  /*
    Each product variant comes with a selling plan selection box that the buyer can interact with.
    When a buyer chooses a different variant, we ensure that only the relevant selling plan selection box is displayed.
    This guarantees that only the selling plan associated with the selected variant is shown.
  */
  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  /*
    The functions listenToVariantChange() and listenToAddToCartForms() are implemented to track when a product variant is altered or when the product form is updated.
    The identification of the variant is crucial as it dictates which selling plan box should be displayed.
  */
  listenToVariantChange() {
    this.listenToAddToCartForms();
    if (this.variantIdInput.tagName === "INPUT") {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });

      variantIdObserver.observe(this.variantIdInput, {
        attributes: true,
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener("change", () => {
        this.handleVariantChange();
      });
    });
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll(".selected-selling-plan-id");
  }

  updateSellingPlanInputsValues() {
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = this.sellingPlanInputValue;
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector(
      'input[type="radio"]:checked'
    );
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"]')
      .forEach((radio) => {
        radio.addEventListener("change", (event) => {
          this.handleRadioButtonChange(event.target);

          var allocationPrice = event.target.getAttribute(
            "data-allocation-price"
          );
          if (!allocationPrice) {
            allocationPrice = event.target.getAttribute("data-variant-price");
            allocationPrice = allocationPrice.replace(/^\$/, "");
          }

          var variantPrice = event.target.getAttribute("data-variant-price");
          var compareAtPrice =
            event.target.getAttribute("data-variant-compare-at-price") ||
            variantPrice; // Use variantPrice if compareAtPrice is not available
          updatePriceAndSavePercentage(
            allocationPrice,
            compareAtPrice,
            variantPrice
          );
        });
      });
  }



    setInitialSelectedSellingPlan() {
      const initialSelectedRadio = this.sellingPlansWidgetContainer.querySelector(
        'input[type="radio"]:checked'
      );
      if (initialSelectedRadio) {
        const selectedPlanId = initialSelectedRadio.dataset.sellingPlanId;
        if (selectedPlanId !== undefined) {
          this.sellingPlanInputs.forEach((sellingPlanInput) => {
            sellingPlanInput.value = selectedPlanId;
          });
        }
        if (initialSelectedRadio.dataset.radioType === 'subscribe_and_save') {
          const allocationPrice = initialSelectedRadio.getAttribute('data-allocation-price');
          const variantPrice = initialSelectedRadio.getAttribute('data-variant-price');
          const compareAtPrice = initialSelectedRadio.getAttribute('data-variant-compare-at-price') || variantPrice;
          if (allocationPrice) {
            updatePriceAndSavePercentage(allocationPrice, compareAtPrice, variantPrice);
          }
        }
      }
    }
}

document
  .querySelectorAll(".selling_plan_app_container")
  .forEach((sellingPlansWidgetContainer) => {
    new SellingPlansWidget(sellingPlansWidgetContainer);
  });


class PurchaseBoxV2 {
  constructor(container) {
    this.container = container;
    this.purchaseCard = container.querySelector('[data-purchase-card]');
    this.packSelector = container.querySelector('[data-pack-selector]');

    try {
      this.data = JSON.parse(container.querySelector('[data-purchase-box-data]')?.textContent || '{}');
    } catch (e) {
      this.data = {};
    }

    if (!this.purchaseCard) return;

    this.initTabs();
    this.initPackCards();
    this.observeVariantChanges();
    this.observeVariantIdAndSyncActiveSection();

    requestAnimationFrame(() => {
      this.updateCardPrices();
      this.updateTabPrices();
      this.updatePackBadges();
      this.updateUpgradeMessage();
    });
  }

  get activeTab() {
    return this.container.dataset.activeTab || 'subscribe';
  }

  get activeSection() {
    return this.container.querySelector('section.selling_plan_theme_integration.active');
  }

  getCurrentVariantData() {
    const formVariantId = this.variantIdInput?.value?.trim();
    const variantId = formVariantId
      ? parseInt(formVariantId, 10)
      : parseInt(this.activeSection?.dataset.variantId, 10);
    if (!variantId) return null;
    return this.data.variants?.find(v => v.id === variantId) || null;
  }

  formatPrice(price) {
    const num = parseFloat(price);
    return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
  }

  initTabs() {
    this.container.querySelectorAll('[data-purchase-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        this.switchTab(tab.dataset.purchaseTab);
      });
    });
  }

  switchTab(tabType) {
    this.container.dataset.activeTab = tabType;

    this.container.querySelectorAll('[data-purchase-tab]').forEach(t => {
      t.classList.toggle('is-active', t.dataset.purchaseTab === tabType);
    });

    const header = this.purchaseCard.querySelector('[data-card-header]');
    if (header) {
      header.textContent = tabType === 'subscribe' ? 'SUBSCRIBE AND SAVE' : 'ONE-TIME PURCHASE';
    }

    const section = this.activeSection;
    if (section) {
      const radioType = tabType === 'subscribe' ? 'subscribe_and_save' : 'one_time_purchase';
      const radio = section.querySelector(`input[data-radio-type="${radioType}"]`);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.syncAllRadios(radioType);
    }

    this.updateCardPrices();
    this.updateTabPrices();
    this.updatePackBadges();
    this.updateUpgradeMessage();

    requestAnimationFrame(() => {
      if (typeof AddToCartText === 'function') AddToCartText();
    });
  }

  syncAllRadios(radioType) {
    this.container.querySelectorAll(`input[data-radio-type="${radioType}"]`).forEach(r => {
      r.checked = true;
    });
    const otherType = radioType === 'subscribe_and_save' ? 'one_time_purchase' : 'subscribe_and_save';
    this.container.querySelectorAll(`input[data-radio-type="${otherType}"]`).forEach(r => {
      r.checked = false;
    });
  }

  initPackCards() {
    if (!this.packSelector) return;

    this.packSelector.querySelectorAll('.pack-card').forEach(card => {
      card.addEventListener('click', () => {
        this.selectPack(card.dataset.packValue);
      });
    });

    this.hideQuantityDropdown();
  }

  hideQuantityDropdown() {
    const hide = () => {
      const label = document.querySelector('[data-variant-option-name*="quantity" i]');
      if (label) {
        const wrapper = label.closest('.options-selection__select-wrapper');
        if (wrapper) wrapper.style.display = 'none';
      }
    };
    hide();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(hide, 50));
    } else {
      setTimeout(hide, 50);
    }
  }

  selectPack(packValue) {
    if (!this.packSelector) return;

    this.packSelector.querySelectorAll('.pack-card').forEach(card => {
      card.classList.toggle('is-active', card.dataset.packValue === packValue);
    });

    // Fix for when options-selection isn't rendered (e.g. product.available == false,
    const variant = this.getVariantForPack(packValue);
    if (!variant) return;

    const variantSelection = document.querySelector('variant-selection');
    if (variantSelection) {
      variantSelection.variant = variant.id;
    }
  }

  updateCardPrices() {
    const isSubscribe = this.activeTab === 'subscribe';
    let vd = this.getCurrentVariantData();

    // One-time: use variant for the selected pack (from active pack card)
    if (!isSubscribe && this.packSelector) {
      const activeCard = this.packSelector.querySelector('.pack-card.is-active');
      const packValue = activeCard?.dataset?.packValue;
      if (packValue != null) {
        const vdForPack = this.getVariantForPack(packValue);
        if (vdForPack) vd = vdForPack;
      }
    }

    if (!vd) return;

    const priceEl = this.purchaseCard.querySelector('[data-card-current-price]');
    const compareEl = this.purchaseCard.querySelector('[data-card-compare-price]');
    const badgeEl = this.purchaseCard.querySelector('[data-card-save-badge]');

    if (isSubscribe) {
      const currentCents = vd.allocationPrice;
      const current = currentCents / 100;
      const refCents = vd.compareAtPrice > 0 && vd.compareAtPrice > vd.price ? vd.compareAtPrice : vd.price;
      const ref = refCents / 100;
      const showCompare = ref > current;
      const savePct = showCompare ? parseFloat(((1 - current / ref) * 100).toFixed(2)) : 0;
      if (priceEl) priceEl.textContent = `$${this.formatPrice(current)}`;
      if (compareEl) compareEl.textContent = showCompare ? `$${this.formatPrice(ref)}` : '';
      if (badgeEl) {
        badgeEl.textContent = savePct > 0 ? `(You Save ${savePct}%)` : '';
        badgeEl.style.display = savePct > 0 ? '' : 'none';
      }
    } else {
      // One-time: use the one-time price from the DOM (radio's data-variant-price) so it's never subscription/25%
      const section = this.container.querySelector(`section.selling_plan_theme_integration[data-variant-id="${vd.id}"]`);
      const oneTimeRadio = section?.querySelector('input[data-radio-type="one_time_purchase"]');
      const priceFromDOM = oneTimeRadio?.getAttribute('data-variant-price');
      const current = priceFromDOM != null ? parseFloat(String(priceFromDOM).replace(/[^0-9.-]/g, '')) : (vd.salePrice != null ? vd.salePrice : vd.price) / 100;

      let ref = current;
      let savePct = 0;
      if (this.packSelector && this.data.packValues && this.data.packValues.length > 1 && this.data.packOptionIndex != null) {
        const packValue = vd.options[this.data.packOptionIndex];
        const packIndex = this.data.packValues.findIndex(pv => String(pv) === String(packValue));
        if (packIndex >= 0) {
          savePct = this.getVolumeDiscount(packValue, packIndex);
          if (savePct > 0) {
            const firstPackVal = this.data.packValues[0];
            const baseV = this.getVariantForPack(firstPackVal);
            const baseUnits = parseInt(firstPackVal, 10) || 1;
            const targetUnits = parseInt(packValue, 10) || 1;
            if (baseV && baseUnits > 0 && targetUnits > 0) {
              ref = (baseV.price / 100 / baseUnits) * targetUnits;
            }
          }
        }
      }
      const showCompare = savePct > 0 && ref > current;
      if (priceEl) priceEl.textContent = `$${this.formatPrice(current)}`;
      if (compareEl) compareEl.textContent = showCompare ? `$${this.formatPrice(ref)}` : '';
      if (badgeEl) {
        badgeEl.textContent = savePct > 0 ? `(You Save ${savePct}%)` : '';
        badgeEl.style.display = savePct > 0 ? '' : 'none';
      }
    }
  }

  /**
   * Find variant for a given pack value, keeping all other options (e.g. flavor) same as current.
   */
  getVariantForPack(packValue) {
    const vd = this.getCurrentVariantData();
    if (!vd || !this.data.variants || !vd.options || this.data.packOptionIndex == null) return null;
    const pi = this.data.packOptionIndex;
    const packValStr = String(packValue);
    return this.data.variants.find((v) => {
      if (!v.options) return false;
      if (String(v.options[pi]) !== packValStr) return false;
      for (let i = 0; i < vd.options.length; i++) {
        if (i !== pi && String(v.options[i]) !== String(vd.options[i])) return false;
      }
      return true;
    }) || null;
  }

  /**
   * Subscription save % for a pack. Uses same logic as purchase-card__save-badge (compareAtPrice when set).
   */
  getSubscriptionDiscountPercent(packValue) {
    const variant = this.getVariantForPack(packValue);
    if (!variant || !variant.allocationPrice) return 0;
    const currentCents = variant.allocationPrice;
    const current = currentCents / 100;
    const refCents = variant.compareAtPrice > 0 && variant.compareAtPrice > variant.price
      ? variant.compareAtPrice
      : variant.price;
    const ref = refCents / 100;
    if (ref <= 0 || current >= ref) return 0;
    return parseFloat(((1 - current / ref) * 100).toFixed(2));
  }

  updateTabPrices() {
    const vd = this.getCurrentVariantData();
    if (!vd) return;

    const subPrice = vd.allocationPrice / 100;
    const subEl = this.container.querySelector('[data-tab-price="subscribe"]');
    const otEl = this.container.querySelector('[data-tab-price="onetime"]');

    if (subEl) subEl.textContent = `- $${this.formatPrice(subPrice)}`;

    // One-time: use the same source as the card (radio's data-variant-price) so sale/metafield pricing is correct
    const section = this.container.querySelector(`section.selling_plan_theme_integration[data-variant-id="${vd.id}"]`);
    const oneTimeRadio = section?.querySelector('input[data-radio-type="one_time_purchase"]');
    const priceFromDOM = oneTimeRadio?.getAttribute('data-variant-price');
    const otPrice = priceFromDOM != null
      ? parseFloat(String(priceFromDOM).replace(/[^0-9.-]/g, ''))
      : (vd.salePrice != null ? vd.salePrice : vd.price) / 100;
    if (otEl) otEl.textContent = `- $${this.formatPrice(otPrice)}`;
  }

  updatePackBadges() {
    const priceRow = this.purchaseCard?.querySelector('[data-card-price-row]');
    if (!this.packSelector) {
      if (priceRow) priceRow.style.display = '';
      return;
    }
    const isSubscribe = this.activeTab === 'subscribe';

    this.packSelector.querySelectorAll('.pack-card').forEach(card => {
      const badge = card.querySelector('.pack-card__badge');
      if (!badge) return;

      const pct = isSubscribe
        ? this.getSubscriptionDiscountPercent(card.dataset.packValue)
        : this.getVolumeDiscount(card.dataset.packValue, parseInt(card.dataset.packIndex, 10));
      badge.textContent = pct > 0 ? `${pct}% OFF` : '';
      badge.style.display = pct > 0 ? '' : 'none';
    });

    const activeCard = this.packSelector.querySelector('.pack-card.is-active');
    if (!activeCard) {
      if (priceRow) priceRow.style.display = '';
      return;
    }
    const activeBadge = activeCard.querySelector('.pack-card__badge');
    const hasBadge = activeBadge && activeBadge.style.display !== 'none' && activeBadge.textContent.trim() !== '';
    if (priceRow) priceRow.style.display = hasBadge ? '' : 'none';
  }

  getVolumeDiscount(packValue, packIndex) {
    if (!this.data.packValues || !this.data.packValues.length) return 0;
    const firstPackVal = this.data.packValues[0];
    const firstStr = String(firstPackVal);
    const packValStr = String(packValue);
    if (packValStr === firstStr) return 0;

    const baseV = this.getVariantForPack(firstPackVal);
    const targetV = this.getVariantForPack(packValue);
    if (!baseV || !targetV) return 0;

    const baseUnits = parseInt(firstPackVal, 10) || 1;
    const targetUnits = parseInt(packValue, 10) || 1;
    if (targetUnits <= 0) return 0;
    const basePPU = baseV.price / baseUnits;
    const targetPPU = targetV.price / targetUnits;
    if (basePPU <= 0) return 0;
    return parseFloat(((1 - targetPPU / basePPU) * 100).toFixed(2));
  }

  updateUpgradeMessage() {
    const msgEl = this.purchaseCard.querySelector('[data-upgrade-message]');
    if (!msgEl) return;

    if (!this.data.packValues || this.data.packValues.length <= 1) {
      msgEl.innerHTML = '';
      msgEl.className = 'upgrade-message';
      return;
    }

    const currentIdx = this.getCurrentPackIndex();
    if (currentIdx < 0) {
      msgEl.innerHTML = '';
      msgEl.className = 'upgrade-message';
      return;
    }

    if (currentIdx >= this.data.packValues.length - 1) {
      msgEl.textContent = "Congrats! You're Getting The Best Value!";
      msgEl.className = 'upgrade-message best-value';
      return;
    }

    const nextPack = this.data.packValues[currentIdx + 1];
    let savePct = 0;

    // Use same percentage as pack-card__badge: subscription uses allocation discount, one-time uses volume discount
    if (this.activeTab === 'subscribe') {
      savePct = this.getSubscriptionDiscountPercent(nextPack);
    } else {
      savePct = this.getVolumeDiscount(nextPack, currentIdx + 1);
    }

    const displayPct = typeof savePct === 'number' && !Number.isNaN(savePct) ? savePct : 0;
    const pctText = displayPct % 1 === 0 ? String(Math.round(displayPct)) : displayPct.toFixed(1);
    msgEl.className = 'upgrade-message';
    msgEl.innerHTML = displayPct > 0
      ? `Upgrade To a <span>${nextPack}</span> And <span>Save ${pctText}%</span>`
      : `Upgrade To a <span>${nextPack}</span>`;
  }

  getCurrentPackIndex() {
    if (!this.packSelector) return -1;
    const active = this.packSelector.querySelector('.pack-card.is-active');
    return active ? parseInt(active.dataset.packIndex) : 0;
  }

  get variantIdInput() {
    const form = this.container.closest('form[action*="/cart/add"]') ||
      document.querySelector('[data-product-form][action*="/cart/add"]');
    return form?.querySelector('input[name="id"]') || form?.querySelector('select[name="id"]');
  }

  /**
   * When the form's variant ID changes (e.g. after pack selection), update which
   * section has the "active" class so price and ATC text read the correct variant.
   * Without this, the active section stays as the initial Liquid-rendered one.
   * Listens to variant-change (theme fires after updating the variant id input).
   */
  observeVariantIdAndSyncActiveSection() {
    const variantSelection = document.querySelector('variant-selection');
    if (!variantSelection) return;

    variantSelection.addEventListener('variant-change', () => {
      setTimeout(() => {
        const input = this.variantIdInput;
        if (!input) return;
        const variantId = (input.value || '').trim();
        if (!variantId) return;

        this.container.querySelectorAll('section.selling_plan_theme_integration').forEach(section => {
          const isActive = section.dataset.variantId === variantId;
          section.classList.toggle('active', isActive);
          section.classList.toggle(hiddenClass, !isActive);
        });

        const activeSection = this.container.querySelector('section.selling_plan_theme_integration.active');
        const checkedRadio = activeSection?.querySelector('input[type="radio"]:checked');
        if (checkedRadio && typeof updatePriceAndSavePercentage === 'function') {
          let allocationPrice = checkedRadio.getAttribute('data-allocation-price');
          if (!allocationPrice) {
            allocationPrice = checkedRadio.getAttribute('data-variant-price') || '';
            allocationPrice = allocationPrice.replace(/^\$/, '');
          }
          const variantPrice = checkedRadio.getAttribute('data-variant-price') || '';
          const compareAtPrice = checkedRadio.getAttribute('data-variant-compare-at-price') || variantPrice;
          updatePriceAndSavePercentage(allocationPrice, compareAtPrice, variantPrice);
        }
        if (typeof AddToCartText === 'function') AddToCartText();
        this.updateCardPrices();
        this.updatePackBadges();
        this.updateUpgradeMessage();
      }, 0);
    });
  }

  observeVariantChanges() {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.target.classList.contains('active') && !m.target.classList.contains(hiddenClass)) {
          this.onVariantChanged();
          break;
        }
      }
    });

    this.container.querySelectorAll('section.selling_plan_theme_integration').forEach(section => {
      observer.observe(section, { attributes: true, attributeFilter: ['class'] });
    });
  }

  onVariantChanged() {
    this.syncRadioToTab();
    this.syncPackCardState();
    this.updateCardPrices();
    this.updateTabPrices();
    this.updatePackBadges();
    this.updateUpgradeMessage();

    requestAnimationFrame(() => {
      if (typeof AddToCartText === 'function') AddToCartText();
    });
  }

  syncRadioToTab() {
    const section = this.activeSection;
    if (!section) return;

    const radioType = this.activeTab === 'subscribe' ? 'subscribe_and_save' : 'one_time_purchase';
    const radio = section.querySelector(`input[data-radio-type="${radioType}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncPackCardState() {
    if (!this.packSelector || this.data.packOptionIndex < 0) return;
    const vd = this.getCurrentVariantData();
    if (!vd) return;

    const currentPack = vd.options[this.data.packOptionIndex];
    this.packSelector.querySelectorAll('.pack-card').forEach(card => {
      card.classList.toggle('is-active', card.dataset.packValue === currentPack);
    });
  }
}

document.querySelectorAll(".purchase-box-v2").forEach(container => {
  new PurchaseBoxV2(container);
});
